//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const WriteFormSearchDataToDatabase: FeatureFlag = {"Id":"WriteFormSearchDataToDatabase","Label":"(KILL)[10.24]WriteFormSearchDataToDatabase","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, form search data is computed and stored encrypted in the database on save and used as a cache during OpenSearch reindexing.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
